document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  function activateTab(tabName) {
    tabButtons.forEach((btn) => btn.classList.remove("active"));
    tabContents.forEach((content) => content.classList.remove("active"));

    const button = document.querySelector(`[data-tab="${tabName}"]`);
    const content = document.getElementById(tabName);
    if (button) button.classList.add("active");
    if (content) content.classList.add("active");
  }

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      activateTab(this.getAttribute("data-tab"));
    });
  });

  if (tabButtons.length > 0) {
    activateTab(tabButtons[0].getAttribute("data-tab"));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const reviewsText = document.querySelector(".reviews-text");
  const reviewsTabButton = document.querySelector(".review-button");
  const reviewsTabContent = document.querySelector(".review-content");

  if (reviewsText && reviewsTabButton && reviewsTabContent) {
    reviewsText.addEventListener("click", function () {
      document.querySelectorAll(".tab-button").forEach((button) => {
        button.classList.remove("active");
      });
      reviewsTabButton.classList.add("active");

      document.querySelectorAll(".tab-content").forEach((content) => {
        content.classList.remove("active");
      });
      reviewsTabContent.classList.add("active");

      reviewsTabButton.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    });
  }
});
